<template>
  <div class="footer">
    <div class="middle">
      <div class="footer-top">
        <div class="footer-img">
          <img src="../../../assets/img/shouye/logo2.png">
        </div>
      </div>
      <div class="footer-bootom">

        <div class="ft-left">


          <ul>
            <li>{{ this.$MyConstant('Api_CONSTANT.menu.PublicMenu.about.name_'+MY_CONSTANT.sqlWhereLang) }}</li>
            <li v-for="item in this.$MyConstant('Api_CONSTANT.menu.PublicMenu.about.list')"><custom-link :to="item.url">{{ item['name_'+MY_CONSTANT.sqlWhereLang]}}</custom-link></li>
          </ul>
          <ul>
            <li>{{ this.$MyConstant('Api_CONSTANT.menu.PublicMenu.exhibitor_info.name_'+MY_CONSTANT.sqlWhereLang) }}</li>
            <li v-for="item in this.$MyConstant('Api_CONSTANT.menu.PublicMenu.exhibitor_info.list')"><custom-link :to="item.url">{{ item['name_'+MY_CONSTANT.sqlWhereLang]}}</custom-link></li>


          </ul>
          <ul>
            <li>{{ this.$MyConstant('Api_CONSTANT.menu.PublicMenu.famous.name_'+MY_CONSTANT.sqlWhereLang) }}</li>
            <li v-for="item in this.$MyConstant('Api_CONSTANT.menu.PublicMenu.famous.list')"><custom-link :to="item.url">{{ item['name_'+MY_CONSTANT.sqlWhereLang]}}</custom-link></li>


          </ul>
          <ul>
            <li>{{ this.$MyConstant('Api_CONSTANT.menu.PublicMenu.trip.name_'+MY_CONSTANT.sqlWhereLang) }}</li>
            <li v-for="item in this.$MyConstant('Api_CONSTANT.menu.PublicMenu.trip.list')"><custom-link :to="item.url">{{ item['name_'+MY_CONSTANT.sqlWhereLang]}}</custom-link></li>
          </ul>
          <ul>
            <li>FAQ</li>
            <li><custom-link to="/SinglePage/monomial/contact">{{ MY_CONSTANT.Lang.contact }}</custom-link></li>
            <!-- <li><custom-link to="/media_enquiry.html">在线咨询</a></li> -->

          </ul>
        </div>
        <div class="ft-right" style="display:flex;">
          <ul style="margin-right: 30px;">
            <li>{{ this.$MyConstant('Lang.QrCodeTitle') }}</li>
            <li><img src="https://51kufei.oss-cn-shenzhen.aliyuncs.com/upload/20211020/2e7264eb6eb98db1c6d72b18a3e17b9a.png"></li>
          </ul>
          <ul>
            <li>{{ this.$MyConstant('Lang.QrCodeTitle2') }}</li>
            <li><img src="../../../assets/img/shouye/code.png"></li>
            <!-- <li><custom-link to="http://wpa.qq.com/msgrd?v=3&uin=2279033090&site=qq&menu=yes"><img src="../../../assets/img/shouye/qq.png"></a><custom-link to="#"><img
                  src="../../../assets/img/shouye/wexin.png"></a></li> -->


          </ul>

        </div>

      </div>

      <div class="footer-aa">
        <div class="middle">
          <p>© 1989 - {{ this.$MyConstant('CurrentYear') }}
            {{ this.$MyConstant('sqlWhereLang')=='cn'?'深圳市安博会展有限公司版权所有':'Shenzhen CPSE Exhibition co.,ltd   all right reserved ' }}
            <custom-link to="/">
             cpse.com
            </custom-link>
            <span v-if="this.$MyConstant('sqlWhereLang')=='cn'">
            &nbsp;&nbsp;备案号：
            <custom-link to="http://beian.miit.gov.cn" target="_blank">
              粤ICP备15058649号-3
            </custom-link>
            </span>

          </p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
 mounted() {


 }
};


</script>

<style scoped>

</style>
